import { message } from 'antd'

export function UpdateSuccess(msg = null, callback = () => {}) {
  const content = msg ?? 'Updated successfully'
  message.success(content).then(() => {
    callback()
  })
}
